/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { BUSINESS_LINES_TABS } from 'containers/pricing/common/settings'
import { get } from 'utils/lodash'

const initialState = {
  hideArchived: false,
  businessLine: BUSINESS_LINES_TABS.ALL_BUSINESS_LINES,
}

const rentalFeesSlice = createSlice({
  name: 'persistentRentalFees',
  initialState: { ...initialState },
  reducers: {
    setHideArchivedRentalFees: (state, action) => {
      state.hideArchived = action.payload
    },
    setSelectedRentalFeesBusinessLine: (state, action) => {
      state.businessLine = action.payload
    },
  },
})

export const { setHideArchivedRentalFees, setSelectedRentalFeesBusinessLine } = rentalFeesSlice.actions

export const selectHideArchivedRentalFees = s => get(s, 'persistentRentalFees.hideArchived')

export const selectSelectedRentalFeesBusinessLine = s => get(s, 'persistentRentalFees.businessLine', BUSINESS_LINES_TABS.ALL_BUSINESS_LINES)
export default rentalFeesSlice.reducer
